import React__default from 'react';
import { useConfiguratorContext } from '@grandvisionhq/configurator';
import { useSelector, useDispatch, statusSuccess } from '@grandvisionhq/state';
import '../../../state/actions.js';
import '../../../state/add-to-cart/selectors.js';
import '../../../state/bundles/selectors.js';
import '../../../state/bundles/reducer.js';
import { getManualPrescriptionValidationState, getPrescription, getSelectedFrame } from '../../../state/configurator/selectors.js';
import '../../../state/configurator/reducer.js';
import '../../../state/products/selectors.js';
import '../../../state/products/reducer.js';
import { isPupillaryDistance } from '../../../utils/is-pupillary-distance.js';
import { updatePrescriptionValue } from '../../../state/configurations/actions.js';

const usePrescriptionFormColumn = ({ side , parametersType ='all'  })=>{
    const { hasAttemptedNextStep: isSubmitted  } = useConfiguratorContext();
    const manualPrescriptionValidationState = useSelector(getManualPrescriptionValidationState);
    const dispatch = useDispatch();
    const prescription = useSelector(getPrescription);
    const frame = useSelector(getSelectedFrame);
    const handleChange = React__default.useCallback((parameter, value)=>{
        if (!frame) {
            return;
        }
        dispatch(updatePrescriptionValue({
            side,
            frameSku: frame.sku,
            parameter,
            value
        }));
    }, [
        dispatch,
        frame
    ]);
    if (!statusSuccess(prescription) || !frame) {
        // Loading / error states are handled further up the tree
        return null;
    }
    const prescriptionValidationState = isSubmitted ? manualPrescriptionValidationState === null || manualPrescriptionValidationState === void 0 ? void 0 : manualPrescriptionValidationState[side] : undefined;
    let opticalParameters = prescription.result.parameters;
    if (parametersType === 'pupillaryDistance') {
        opticalParameters = opticalParameters.filter((param)=>isPupillaryDistance(param)
        );
    } else if (parametersType === 'nonPupillaryDistance') {
        opticalParameters = opticalParameters.filter((param)=>!isPupillaryDistance(param)
        );
    }
    return {
        prescriptionData: prescription.result[side],
        idExtension: frame.sku,
        handleChange,
        prescriptionValidationState,
        isSubmitted,
        opticalParameters
    };
};

export { usePrescriptionFormColumn };
//# sourceMappingURL=use-prescription-form-column.js.map
